import { createSlice, current } from '@reduxjs/toolkit';
import {
	getIntakeCoordinatesList,
	getIntakeCoordinatesItem,
	addNewIntakeCoordinates,
	updateIntakeCoordinates,
	deleteIntakeCoordinates,
} from './thunk';

export const initialState = {
	itemIntakeCoordinatesList: [],
	itemIntakeCoordinates: null,
	isIntakeCoordinatesLoading: false,
	isIntakeCoordinatesSuccess: false,
	statementList: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const IntakeCoordinatesSlice = createSlice({
	name: 'IntakeCoordinates',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		clearIntakeCoordinates(state) {
			state.itemIntakeCoordinatesList = [];
			state.statementList = [];
		},
	},
	extraReducers: builder => {
		builder.addCase(getIntakeCoordinatesList.pending, state => {
			state.isLoadingList = true;
			state.isIntakeCoordinatesSuccess = false;
		});

		builder.addCase(getIntakeCoordinatesList.fulfilled, (state, action) => {
			state.itemIntakeCoordinatesList = action.payload;
			state.statementList = action.payload;
			state.isLoadingList = false;
			state.isIntakeCoordinatesSuccess = true;
		});

		builder.addCase(getIntakeCoordinatesList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isIntakeCoordinatesSuccess = false;
		});

		builder.addCase(getIntakeCoordinatesItem.pending, state => {
			state.isIntakeCoordinatesLoading = true;
			state.isIntakeCoordinatesSuccess = false;
		});

		builder.addCase(getIntakeCoordinatesItem.fulfilled, (state, action) => {
			state.itemIntakeCoordinates = action.payload;
			state.isIntakeCoordinatesLoading = false;
			state.isIntakeCoordinatesSuccess = true;
		});

		builder.addCase(getIntakeCoordinatesItem.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isIntakeCoordinatesLoading = false;
			state.isIntakeCoordinatesSuccess = false;
		});

		builder.addCase(addNewIntakeCoordinates.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewIntakeCoordinates.fulfilled, (state, action) => {
			state.itemIntakeCoordinatesList.push(action.payload);
			state.statementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewIntakeCoordinates.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateIntakeCoordinates.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateIntakeCoordinates.fulfilled, (state, action) => {
			state.itemIntakeCoordinatesList = state.itemIntakeCoordinatesList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(updateIntakeCoordinates.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteIntakeCoordinates.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteIntakeCoordinates.fulfilled, (state, action) => {
			state.itemIntakeCoordinatesList = current(state.itemIntakeCoordinatesList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.statementList = current(state.statementList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteIntakeCoordinates.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});
	},
});

export const { setRequireCloseModal, clearIntakeCoordinates } = IntakeCoordinatesSlice.actions;

export default IntakeCoordinatesSlice.reducer;
